/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Explorer_Info_Copy_Id_Failed_ToastInputs */

const en_explorer_info_copy_id_failed_toast = /** @type {(inputs: Explorer_Info_Copy_Id_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to copy ID: ${i?.error}`)
};

const fr_explorer_info_copy_id_failed_toast = /** @type {(inputs: Explorer_Info_Copy_Id_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec de la copie de l'ID : ${i?.error}`)
};

const de_explorer_info_copy_id_failed_toast = /** @type {(inputs: Explorer_Info_Copy_Id_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler beim Kopieren der ID: ${i?.error}`)
};

const it_explorer_info_copy_id_failed_toast = /** @type {(inputs: Explorer_Info_Copy_Id_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile copiare l'ID: ${i?.error}`)
};

const ru_explorer_info_copy_id_failed_toast = /** @type {(inputs: Explorer_Info_Copy_Id_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось скопировать ID: ${i?.error}`)
};

const es_explorer_info_copy_id_failed_toast = /** @type {(inputs: Explorer_Info_Copy_Id_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo copiar el ID: ${i?.error}`)
};

const zh_cn2_explorer_info_copy_id_failed_toast = /** @type {(inputs: Explorer_Info_Copy_Id_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`复制 ID 失败：${i?.error}`)
};

const ja_explorer_info_copy_id_failed_toast = /** @type {(inputs: Explorer_Info_Copy_Id_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`IDのコピーに失敗しました: ${i?.error}`)
};

const hi_explorer_info_copy_id_failed_toast = /** @type {(inputs: Explorer_Info_Copy_Id_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`आईडी ${i?.error} कॉपी करने में विफल`)
};

const pt_pt2_explorer_info_copy_id_failed_toast = /** @type {(inputs: Explorer_Info_Copy_Id_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao copiar o ID: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to copy ID: {error}" |
*
* @param {Explorer_Info_Copy_Id_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_copy_id_failed_toast = /** @type {((inputs: Explorer_Info_Copy_Id_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Copy_Id_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_copy_id_failed_toast(inputs)
	if (locale === "de") return de_explorer_info_copy_id_failed_toast(inputs)
	if (locale === "it") return it_explorer_info_copy_id_failed_toast(inputs)
	if (locale === "ru") return ru_explorer_info_copy_id_failed_toast(inputs)
	if (locale === "es") return es_explorer_info_copy_id_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_copy_id_failed_toast(inputs)
	if (locale === "ja") return ja_explorer_info_copy_id_failed_toast(inputs)
	if (locale === "hi") return hi_explorer_info_copy_id_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_copy_id_failed_toast(inputs)
	return en_explorer_info_copy_id_failed_toast(inputs)
});